{
  "close": "Zavřít",
  "notifications": "Upozornění"
}
